import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { MessageProvider } from './context/MessageContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Prompts from './pages/Prompts';
import CaseDetail from './pages/CaseDetail';
import Debug from './pages/Debug';
import AppLayout from './components/AppLayout';
import './styles/App.css';
import './styles/MessageLog.css';

// Protected route wrapper
function PrivateRoute({ children }) {
  const { currentUser, loading } = useAuth();
  
  if (loading) {
    return <div className="loading-screen">Loading...</div>;
  }
  
  return currentUser ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <AuthProvider>
      <MessageProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            
            {/* Main layout with shared header and navigation */}
            <Route 
              path="/dashboard" 
              element={
                <PrivateRoute>
                  <AppLayout />
                </PrivateRoute>
              } 
            />
            
            <Route 
              path="/prompts" 
              element={
                <PrivateRoute>
                  <AppLayout />
                </PrivateRoute>
              } 
            />
            
            {/* Legacy routes for deep linking */}
            <Route 
              path="/matters/:caseId" 
              element={
                <PrivateRoute>
                  <CaseDetail />
                </PrivateRoute>
              } 
            />
            
            {/* Debug route - accessible without authentication */}
            <Route path="/debug" element={<Debug />} />
            
            <Route path="/" element={<Navigate to="/dashboard" />} />
            <Route path="*" element={<Navigate to="/dashboard" />} />
          </Routes>
        </Router>
      </MessageProvider>
    </AuthProvider>
  );
}

export default App;